import React from 'react';
import {connect} from 'react-redux';

export default function Introduction() {
  return <div className="Introduction">
    <div className="so-back">
      <div className="so-chunk">
        <div className="Introduction__container">
          <h2>Sabay Settlement Network</h2>
          <p className="Introduction__lead">This is the administration portal for the Sabay Settlement Network. Access to the test network is open however to access the production host a VPN key must be used</p>

          <p>Please note the Friendbot is disabled on both networks</p>

          <p>This project is based on the Stellar Laboratory</p>
        </div>
      </div>
    </div>
  </div>
}




// WEBPACK FOOTER //
// ./src/components/Introduction.js